import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor";

var _props;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SiftText from "@/components/sift/SiftText";
import SiftSelect from "@/components/sift/SiftSelect";
import SiftSelects from "@/components/sift/SiftSelects";
import SiftDate from "@/components/sift/SiftDate";
import SiftBEDate from "@/components/sift/SiftBEDate";
import SiftRadio from "@/components/sift/SiftRadio";
import SiftCascader from "@/components/sift/SiftCascader";
import SiftYear from "@/components/sift/SiftYear";
export default {
  name: "Sift",
  components: {
    SiftText: SiftText,
    SiftSelect: SiftSelect,
    SiftSelects: SiftSelects,
    SiftDate: SiftDate,
    SiftBEDate: SiftBEDate,
    SiftRadio: SiftRadio,
    SiftCascader: SiftCascader,
    SiftYear: SiftYear
  },
  props: (_props = {}, _defineProperty(_props, "sift-data", {
    type: Array,
    default: function _default() {
      return [];
    }
  }), _defineProperty(_props, "col", {
    type: Number,
    default: 6
  }), _props),
  data: function data() {
    return {
      labelWidth: 0
    };
  },
  computed: {},
  created: function created() {
    var _iterator = _createForOfIteratorHelper(this.siftData),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (item.type == "cascader") {
          var _iterator2 = _createForOfIteratorHelper(item.selectList),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var value = _step2.value;
              this.labelWidth = value.label.length > this.labelWidth ? value.label.length : this.labelWidth;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        } else {
          this.labelWidth = item.label.length > this.labelWidth ? item.label.length : this.labelWidth;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    this.labelWidth = this.labelWidth + 0.5;
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    getValue: function getValue() {
      var _this = this;

      var obj = {};
      this.siftData.forEach(function (item, index) {
        if (item.type == "bedate" || item.type == "cascader") {
          var value = _this.$refs.siftComp[index].getValue();

          obj = _objectSpread(_objectSpread({}, obj), value);
        } else {
          obj[item.key] = _this.$refs.siftComp[index].getValue();
        }
      });
      return obj;
    },
    resetvalue: function resetvalue() {
      var _this2 = this;

      var obj = {};
      this.siftData.forEach(function (item, index) {
        if (item.type == "bedate" || item.type == "cascader") {
          _this2.$refs.siftComp[index].resetValue();
        } else {
          _this2.$refs.siftComp[index].resetValue();
        }
      });
      return obj;
    },
    siftName: function siftName(type) {
      switch (type) {
        case "text":
          return SiftText;

        case "select":
          return SiftSelect;

        case "selects":
          return SiftSelects;

        case "date":
          return SiftDate;

        case "bedate":
          return SiftBEDate;

        case "radio":
          return SiftRadio;

        case "cascader":
          return SiftCascader;

        case "year":
          return SiftYear;

        default:
          break;
      }
    },
    changeValue: function changeValue(absolute) {
      if (absolute || this.siftData.length == 1) {
        this.$emit("change");
      }
    }
  },
  watch: {},
  filters: {}
};